import { call } from 'redux-saga/effects';
import { toNumber } from 'lodash-es';
import executeGraphQLRequest from 'GrooveHTTPClient/executeGraphQLRequest';
import Task from 'Modules/Spaces/show/records/Task';

import query from 'Modules/Spaces/show/gql/mutations/WorkspaceSObjectTaskBasicUpdate.mutation.gql';

export default function* updateSObjectTask({ ids, fields, options }) {
  const response = yield call(executeGraphQLRequest, {
    query,
    variables: {
      ids,
      fields,
      options,
    },
  });

  const error = response.get('error');
  if (error) {
    throw error;
  }

  const inaccessibleTaskIds = response.getIn([
    'data',
    'workspaceSObjectTaskBasicUpdate',
    'inaccessibleIds',
  ]);
  if (!inaccessibleTaskIds.isEmpty()) {
    throw new Error('DeleteSObjectTask: Inaccessible task id provided');
  }

  const updatedTask = response
    .getIn(['data', 'workspaceSObjectTaskBasicUpdate', 'workspaceSObjectTasks'])
    .first();

  const formattedTask = Task.from({
    id: toNumber(updatedTask.get('id')),
    creatorId: toNumber(updatedTask.getIn(['creator', 'id'])),
    assigneeId: toNumber(updatedTask.getIn(['assignee', 'id'])),
    createdAt: updatedTask.get('createdAt'),
    completedAt: updatedTask.get('completedAt'),
    dueAt: updatedTask.get('dueAt'),
    sfdcId: updatedTask.get('sfdcId'),
    priority: updatedTask.get('priority'),
    description: updatedTask.get('description'),
  });
  return formattedTask;
}
